import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ProgramCard = ({ program, onApply }) => {
  const navigate = useNavigate();
  const { isSignedIn } = useAuth();

  const handleApplyClick = () => {
    if (!isSignedIn) {
      navigate('/user-login');
    } else {
      onApply(program?.id);
    }
  };
  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-5 lg:p-6 hover:shadow-warm-md transition-smooth">
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-3 md:gap-4 mb-4">
        <div className="flex-1 min-w-0">
          <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-2">
            {program?.name}
          </h3>
          <p className="text-sm md:text-base text-muted-foreground font-caption line-clamp-2">
            {program?.description}
          </p>
        </div>
        {program?.featured && (
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-accent/10 text-accent rounded-md text-xs font-caption font-medium whitespace-nowrap">
            <Icon name="Star" size={14} />
            Featured
          </span>
        )}
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4 mb-4 md:mb-5">
        <div className="flex items-center gap-2">
          <Icon name="Clock" size={16} color="var(--color-primary)" />
          <div>
            <p className="text-xs text-muted-foreground font-caption">Duration</p>
            <p className="text-sm md:text-base font-medium text-foreground data-text">
              {program?.duration}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="Users" size={16} color="var(--color-primary)" />
          <div>
            <p className="text-xs text-muted-foreground font-caption">Class Size</p>
            <p className="text-sm md:text-base font-medium text-foreground data-text">
              {program?.classSize}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2 col-span-2 md:col-span-1">
          <Icon name="DollarSign" size={16} color="var(--color-primary)" />
          <div>
            <p className="text-xs text-muted-foreground font-caption">Tuition</p>
            <p className="text-sm md:text-base font-medium text-foreground data-text">
              {program?.tuition}
            </p>
          </div>
        </div>
      </div>
      <div className="flex flex-wrap gap-2 mb-4 md:mb-5">
        {program?.features?.map((feature, index) => (
          <span
            key={index}
            className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-muted text-foreground rounded text-xs font-caption"
          >
            <Icon name="Check" size={12} color="var(--color-success)" />
            {feature}
          </span>
        ))}
      </div>
      <div className="flex flex-col sm:flex-row gap-2 md:gap-3">
        <Button
          variant="default"
          fullWidth
          iconName="PenTool"
          iconPosition="left"
          onClick={handleApplyClick}
        >
          Apply Now
        </Button>
        <Button
          variant="outline"
          fullWidth
          iconName="Info"
          iconPosition="left"
        >
          Details
        </Button>
      </div>
    </div>
  );
};

export default ProgramCard;